import { makeStyles } from "@material-ui/core/styles";

export const useCatalogSkeletonStyles = makeStyles(() => ({
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
    gap: 24,

    /* Tablets */
    "@media (max-width: 940px)": {
      gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
      gap: 16,
    },

    /* Small phones */
    "@media (max-width: 600px)": {
      gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
      gap: 12,
    },
  },

  card: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 16,
    height: 356,
    display: "flex",
    flexDirection: "column",

    /* Tablets */
    "@media (max-width: 940px)": {
      height: 280,
      padding: 14,
    },

    /* Small phones */
    "@media (max-width: 600px)": {
      height: 240,
      padding: 12,
    },
  },

  image: {
    width: "100%",
    height: 160,
    borderRadius: 12,
    backgroundColor: "#f1f1f1",
    marginBottom: 16,
    animation: "$pulse 1.5s ease-in-out infinite",

    "@media (max-width: 940px)": {
      height: 120,
    },

    "@media (max-width: 600px)": {
      height: 100,
    },
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },

  line: {
    height: 12,
    backgroundColor: "#f1f1f1",
    borderRadius: 6,
    animation: "$pulse 1.5s ease-in-out infinite",
  },

  short: {
    width: "40%",
  },

  medium: {
    width: "65%",
  },

  "@keyframes pulse": {
    "0%": { opacity: 1 },
    "50%": { opacity: 0.45 },
    "100%": { opacity: 1 },
  },
}));
